import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { DesertBackground, ContentContainer } from "@faire/retailer-visitor-shared/views/about/components/common";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import React from "react";
import styled from "styled-components";
export var AwardsModule = function() {
    var calculateAnimationOffset = function(index) {
        return 40 + 20 * (Math.ceil((index + 1) / 3) - 1) + index % 3 * 20;
    };
    var valueProps = [
        {
            title: "Best Fashion Marketplace",
            issuer: "Glossy",
            link: "https://www.glossy.co/wp-content/uploads/2021/06/Glossy-Awards-2021-Winners-Guide_061721.pdf"
        },
        {
            title: "Most Passionate Employees",
            issuer: "Digiday",
            link: "https://digiday.com/awards/the-digiday-worklife-awards-shortlist-keeping-collaboration-and-charity-alive-during-an-unprecedented-year/"
        },
        {
            title: "Small Business Innovator Awards",
            issuer: "Forbes",
            link: "https://www.forbes.com/sites/maneetahuja/2021/12/29/forbes-small-business-awards-2020-faire-is-how-mom-and-pop-stand-up-to-amazon/?sh=5f68495a291c"
        },
        {
            title: "Most Innovative Companies",
            issuer: "Fast Company",
            link: "https://www.fastcompany.com/90457893/retail-most-innovative-companies-2020"
        },
        {
            title: "Business Resilience Award",
            issuer: "Modern Retail",
            link: "https://digiday.com/awards/digiday-resilience-awards-winners-how-brands-protected-their-workers-and-gave-back-to-the-world-in-a-time-of-crisis/"
        }
    ];
    return /*#__PURE__*/ _jsx(DesertBackground, {
        children: /*#__PURE__*/ _jsxs(ContentContainer, {
            align: "flex-start",
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: {
                        mobileAndAbove: 72,
                        tabletAndAbove: 88
                    }
                }),
                /*#__PURE__*/ _jsx(SlideIn, {
                    offset: "50px",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.inverse,
                        variant: "displayMSerifRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "ivjQcf",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Awards"
                                }
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: {
                        mobileAndAbove: 48,
                        tabletAndAbove: 64
                    }
                }),
                /*#__PURE__*/ _jsx(Wrapper, {
                    children: valueProps.map(function(value, index) {
                        return /*#__PURE__*/ _jsx(AwardContainer, {
                            children: /*#__PURE__*/ _jsx(StyledColumn, {
                                children: /*#__PURE__*/ _jsxs(SlideIn, {
                                    offset: "".concat(calculateAnimationOffset(index), "px"),
                                    children: [
                                        /*#__PURE__*/ _jsx(AwardTitle, {
                                            variant: {
                                                mobileAndAbove: "sectionHeaderSansMedium",
                                                tabletAndAbove: "displaySSansSemiBold"
                                            },
                                            color: Core.text.inverse,
                                            children: /*#__PURE__*/ _jsx(Anchor, {
                                                href: value.link,
                                                rel: "noreferrer",
                                                target: "_blank",
                                                children: value.title
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            height: "1x"
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            color: Core.text.inverse,
                                            variant: "subheadingSansRegular",
                                            children: value.issuer
                                        }),
                                        /*#__PURE__*/ _jsx(Spacer, {
                                            height: "4x"
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: {
                        mobileAndAbove: 24,
                        tabletAndAbove: 80
                    }
                })
            ]
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-56002170-0"
})([
    "display:flex;flex-wrap:wrap;justify-content:space-between;"
]);
var AwardContainer = styled.div.withConfig({
    componentId: "sc-56002170-1"
})([
    "",
    "{width:33.3%;}"
], responsiveMediaQueries.desktopAndAbove);
var AwardTitle = styled(Typography).withConfig({
    componentId: "sc-56002170-2"
})([
    "text-decoration:underline;",
    "{max-width:200px;}"
], responsiveMediaQueries.mobile);
var StyledColumn = styled(Column).withConfig({
    componentId: "sc-56002170-3"
})([
    "max-width:300px;"
]);
